module.exports = __webpack_public_path__ + "img/icon_close.458d74fe.png";